export enum EventConfirmationPageCardType {
  YES = 'YES',
  NO = 'NO',
  MAYBE = 'MAYBE',
  WAITLIST = 'WAITLIST',
  PENDING = 'PENDING_APPROVAL',
  WITHDRAW = 'WITHDRAW',
  BOOK_A_SLOT = 'BOOK_A_SLOT',
  CONFIRMATION = 'CONFIRMATION',
  CREATE_ACCOUNT = 'CREATE_ACCOUNT',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  CREATE_EVENT = 'CREATE_EVENT',
  HOST = 'HOST',

  SHARE_OPTIONS = 'SHARE_OPTIONS',

  PREMIUM_CUSTOM_TEXT = 'PREMIUM_CUSTOM_TEXT',
}
